import React, { useMemo } from 'react';
import { Form, Button, Space } from 'antd';
import type { FormProps as AntFormProps } from 'antd';
import { useAndStore } from '../../base/store/useAndStore';
import { getDataSetStoreKey } from '../../base/storeKeyUtils';
import { createCommand } from '../../base/actionParser';
import type { BaseComponentProps, DataSetConfig } from '../../types/common';

export interface AndSimpleFormProps extends Omit<AntFormProps, 'onFinish' | 'onReset'>, BaseComponentProps, DataSetConfig {
  submitAction?: string;
  resetAction?: string;
  showSubmit?: boolean;
  showReset?: boolean;
  submitText?: string;
  resetText?: string;
  onFinish?: (values: any) => void;
  onReset?: () => void;
}

export const AndSimpleForm: React.FC<AndSimpleFormProps> = ({
  id, sessionId, develop, dataSet, dataSetField, submitAction, resetAction, showSubmit = true, showReset = true, submitText = '提交', resetText = '重置', onFinish, onReset, children, ...restProps
}) => {
  const [form] = Form.useForm();
  const addCommand = useAndStore((state) => state.addCommand);
  const setDataSet = useAndStore((state) => state.setDataSet);
  const dataSetKey = useMemo(
    () => getDataSetStoreKey(sessionId, dataSet),
    [sessionId, dataSet]
  );

  const handleFinish = (values: any) => {
    if (onFinish) { onFinish(values); return; }
    if (dataSetKey && dataSetField) setDataSet(dataSetKey, dataSetField, values);
    if (submitAction && sessionId) {
      addCommand(sessionId, createCommand(submitAction, values));
    }
  };

  const handleReset = () => {
    form.resetFields();
    if (onReset) { onReset(); return; }
    if (resetAction && sessionId) {
      addCommand(sessionId, createCommand(resetAction, null));
    }
  };

  return (
    <Form {...restProps} form={form} onFinish={handleFinish}>
      {children as React.ReactNode}
      {(showSubmit || showReset) && (
        <Form.Item>
          <Space>
            {showSubmit && <Button type="primary" htmlType="submit">{submitText}</Button>}
            {showReset && <Button onClick={handleReset}>{resetText}</Button>}
          </Space>
        </Form.Item>
      )}
    </Form>
  );
};

export default AndSimpleForm;
